// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.link_styles[data-v-c06f65d6]:hover {\n  color: rgb(180, 210, 226) !important;\n}\n", ""]);
// Exports
module.exports = exports;
